module.exports = __webpack_public_path__ + "static/media/amazon.43c5eacc.svg";